import type { ConflictCardProps } from "./types-conflict-card";
import { ConflictCardView } from "./view-conflict-card";

/** Card, em portal, com as obras e datas do conflito. */
export function ConflictCard(props: ConflictCardProps) {
  return <ConflictCardView {...props} />;
}

export type * from "./types-conflict-card";
